import React, { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext({ currency: "INR", setCurrency: () => {}, rate: 83 });

export function CurrencyProvider({ children, rate = 83 }) {
  const [currency, setCurrency] = useState(() => localStorage.getItem("atf_currency") || "INR");
  useEffect(() => { localStorage.setItem("atf_currency", currency); }, [currency]);
  return <Ctx.Provider value={{ currency, setCurrency, rate }}>{children}</Ctx.Provider>;
}

export const useCurrency = () => useContext(Ctx);
